import { createContext, useContext } from "react";
import type { SubTemplateData } from "@/types/evaluation";

interface UnifiedValuesContextValue {
  values: Record<string, unknown>;
  setFieldValue: (fieldId: string, value: unknown) => void;
  fillVariables: Record<string, string>;
  interpolate: (text: string) => string;
  subTemplateValues: Record<string, SubTemplateData>;
  setSubTemplateValue: (fieldId: string, data: SubTemplateData) => void;
  sectionToggles: Record<string, boolean>;
  onToggleSection: (sectionId: string) => void;
  collapsedSections: Record<string, boolean>;
  onCollapseSection: (sectionId: string) => void;
  fieldToggles: Record<string, boolean>;
  onToggleField: (fieldId: string) => void;
}

export const UnifiedValuesContext = createContext<UnifiedValuesContextValue>({
  collapsedSections: {},
  fieldToggles: {},
  fillVariables: {},
  interpolate: (t) => t,
  onCollapseSection: () => {
    /* no-op */
  },
  onToggleField: () => {
    /* no-op */
  },
  onToggleSection: () => {
    /* no-op */
  },
  sectionToggles: {},
  setFieldValue: () => {
    /* no-op */
  },
  setSubTemplateValue: () => {
    /* no-op */
  },
  subTemplateValues: {},
  values: {},
});

export function useUnifiedValues() {
  return useContext(UnifiedValuesContext);
}
